import { render, staticRenderFns } from "./AiBot.vue?vue&type=template&id=61a5fe90&lang=pug"
import script from "./AiBot.vue?vue&type=script&lang=js"
export * from "./AiBot.vue?vue&type=script&lang=js"
import style0 from "./AiBot.vue?vue&type=style&index=0&id=61a5fe90&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports